import { NavLink } from "react-router-dom";
import { IoChevronForwardSharp, IoHomeOutline } from "react-icons/io5";
import useBreadcrumbs from "use-react-router-breadcrumbs";

const S2LicenseBreadcrumbs = ({ account }) => {
  const staticBreadcrumb = ({ content }) => <>{content}</>;
  const accountBreadcrumb = () => <span>{account && account.short_name}</span>;

  const routes = [
    {
      path: "/",
      breadcrumb: staticBreadcrumb,
      props: {
        content: (
          <div className="flex items-center">
            <IoHomeOutline className="mr-3" /> Home
          </div>
        ),
      },
    },
    { path: "/accounts/:id", breadcrumb: accountBreadcrumb },
    {
      path: "/accounts/:id/s2-licenses",
      breadcrumb: staticBreadcrumb,
      props: { content: "S2 Licenses" },
    },
  ];

  const breadcrumbs = useBreadcrumbs(routes);

  return (
    <nav className="flex px-3">
      <ol className="inline-flex items-center space-x-1 md:space-x-3 breadcrumbs">
        {breadcrumbs.map(({ match, breadcrumb }) => (
          <li key={match.pathname} className="inline-flex items-center">
            <NavLink
              to={match.pathname}
              className="inline-flex items-center text-sm text-gray-500 hover:text-blue-500"
            >
              {breadcrumb}
            </NavLink>
            <IoChevronForwardSharp className="ml-3 text-gray-400" />
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default S2LicenseBreadcrumbs;
